/**
 * SignOutModal - Confirmation modal for signing out
 */
import React from 'react';
import Button from '../common/Button';

const SignOutModal = ({ isOpen, onClose, onConfirm, loading = false }) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Modal backdrop */}
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1040 }}
      ></div>

      {/* Modal */}
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1050 }}
      >
        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                <i className="bi bi-box-arrow-right me-2"></i>
                Déconnexion
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
                disabled={loading}
              ></button>
            </div>
            <div className="modal-body">
              <p className="mb-0">
                Êtes-vous sûr de vouloir vous déconnecter ?
              </p>
              <p className="small text-muted mb-0 mt-2">
                Vos données seront sauvegardées automatiquement.
              </p>
            </div>
            <div className="modal-footer">
              <Button
                variant="secondary"
                onClick={onClose}
                disabled={loading}
              >
                Annuler
              </Button>
              <Button
                variant="danger"
                onClick={onConfirm}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Déconnexion...
                  </>
                ) : (
                  <>
                    <i className="bi bi-box-arrow-right me-2"></i>
                    Se déconnecter
                  </>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignOutModal;
